import { useCallback } from 'react';
import { firebaseSignOut } from '../../api/firebase/index';

export const useLogout = () => {
  const logout = useCallback(async () => {
    await firebaseSignOut();
  }, []);

  return { logout };
};

export default useLogout;
